import { usePage } from '@inertiajs/react'

interface AppUser {
  role: 'owner' | 'member'
  is_member: boolean
  email: string
  full_name: string | null
  acting_for: string | null
  plan: string
}

interface BannerProps {
  app_user: AppUser | null
  [key: string]: unknown
}

export default function ActingAsBanner() {
  const { app_user } = usePage<BannerProps>().props

  if (!app_user || !app_user.is_member) return null

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2 text-xs sm:text-sm text-amber-900 flex items-center gap-2">
      <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
      </svg>
      <span>
        <strong>Team Member view</strong> — acting on behalf of{' '}
        <strong>{app_user.acting_for}</strong>. Some actions are limited to the account owner.
      </span>
    </div>
  )
}
